import { statusIcon } from "../activityCompletionRules";
import { isActivityBuilderSectionAccessible } from "../activityWorkflowUtils";

const ActivityMobileStepper = ({
  sections,
  sectionStatuses,
  activeSectionId,
  hasActivityId,
  completedUnlockOrder,
  isResumeEdit,
  onSectionClick,
}) => {
  const activeIndex = sections.findIndex((s) => s.id === activeSectionId);
  const stepNumber = activeIndex >= 0 ? activeIndex + 1 : 1;

  return (
    <div className="space-y-2">
      <p className="text-center text-xs font-semibold text-gray-500">
        Step {stepNumber} of {sections.length}
      </p>
      <div className="flex gap-1 overflow-x-auto pb-1 scrollbar-hide">
        {sections.map((item) => {
          const status = sectionStatuses[item.id] || "not_started";
          const isActive = activeSectionId === item.id;
          const locked = !isActivityBuilderSectionAccessible(
            item.unlockOrder,
            completedUnlockOrder,
            hasActivityId,
            isResumeEdit
          );

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onSectionClick(item.id, item.unlockOrder)}
              className={`shrink-0 rounded-full px-3 py-1.5 text-xs font-medium transition ${
                isActive
                  ? "bg-primary text-white shadow-sm"
                  : locked
                  ? "bg-gray-50 text-gray-400 ring-1 ring-gray-200"
                  : status === "complete"
                  ? "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200"
                  : status === "incomplete"
                  ? "bg-amber-50 text-amber-700 ring-1 ring-amber-200"
                  : "bg-white text-gray-600 ring-1 ring-gray-200"
              }`}
            >
              {locked ? "🔒 " : `${statusIcon(status)} `}
              {item.shortName}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityMobileStepper;
